import shouldUpdate from "./shouldUpdate";
import shallowEqual from "./utils/shallowEqual";
import pick from "./utils/pick";
export function onlyUpdateForKeys(propKeys) {
    return shouldUpdate(function (prev, next) { return !shallowEqual(pick.apply(void 0, [prev].concat(propKeys)), pick.apply(void 0, [next].concat(propKeys))); });
}
export default onlyUpdateForKeys;

//# sourceMappingURL=onlyUpdateForKeys.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/onlyUpdateForKeys.js
// module id = 218
// module chunks = 0